module.exports = __webpack_public_path__ + "images/emoji/wc.13d1eed3113ca2bb8448.png";